<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>


<header id="header" class="fixed-top" >
  <div class="container d-flex align-items-center">

    <img src="https://i.imgur.com/zvMcpGP.png" alt="logo_SAION" height="100" width="150">
    <h1 class="logo me-auto"><a style="color: #a81a04;font-family:Georgia, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif " href="index.html"><img style="margin-left: -5vh;" src="https://i.imgur.com/4S2DgSq.png" alt=""></a></h1>
    <!-- Uncomment below if you prefer to use an image logo -->
    <!-- <a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

    <nav id="navbar" class="navbar order-last order-lg-0">
      <ul>
        <li><a id="etiqueta" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #a81a04;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;" href="admin/indice" class="active">Inicio</a></li>

        <li  class="dropdown danger"><a id="etiqueta" href="#"><span style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif, Times, serif;">Transparencia</span> <i class="bi bi-chevron-down"></i></a>
          <ul style="border-top: solid;border-color: #a81a04;">
            <li><a id="etiqueta" href="admin/articulo-8"  style="font-family:  'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif">Articulo 8</a></li>

            <li><a id="etiqueta" href="admin/articulo-15" style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif">Articulo 15</a>
            </li>
          </ul>
        </li>

        <li><a id="etiqueta"  style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif">Gabinete</a></li>


        <li><a id="etiqueta"  style="font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif">Trámites y servicios</a></li>

      </ul>
      <i class="bi bi-list mobile-nav-toggle"></i>
    </nav><!-- .navbar -->

    <div class="header-social-links d-flex">
<!--
      <button style="height: 1px; border:transparent; border-color: transparent; margin-top: -6px; margin-left: 15px;color: #a81a04; font-size: 2vh;margin-top: -1.8vh;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
      "  class="facebook">Cerrar Sesión</button> -->

      <!-- <a href="#" class="instagram"><i class="bu bi-instagram"></i></a>
      <a href="#" class="linkedin"><i class="bu bi-linkedin"></i></a> -->
    </div>

  </div>
</header><!-- End Header -->

